import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { queryClient } from './api/queries';
import { Toasts } from './components/Toasts';
import { useLive } from './live/store';
import { debugMedia, debugStats, useMedia } from './live/media';
import { toast } from './components/toast';
import { openSetPose } from './lib/robot';
import './styles/global.css';

if (import.meta.env.DEV) {
  // Debug hook for manual testing (inject fake agent events etc.).
  (window as unknown as { __cruzr: unknown }).__cruzr = { live: useLive, queryClient, media: debugMedia, stats: debugStats, toast, openSetPose, mediaInfo: (s: string) => useMedia.getState().byRobot[s] };
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toasts />
    </QueryClientProvider>
  </StrictMode>,
);
